module.exports = __webpack_public_path__ + "cddcec5d4586669c983bb89a89ffa8f5.pdf";